import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20elegant%20beauty%20and%20wellness%20lifestyle%20concept%20with%20warm%20cream%20and%20blush%20tones%2C%20fresh%20roses%20and%20peonies%20arrangement%2C%20soft%20natural%20lighting%2C%20serene%20atmosphere%2C%20clean%20aesthetic%20background&width=1600&height=600&seq=91mei-cta-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="relative z-10 max-w-[1280px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-white mb-4">
          {t('cta.title')}
        </h2>
        <p className="text-sm md:text-base text-white/85 mb-8 max-w-[500px] mx-auto">
          {t('cta.subtitle')}
        </p>
        <Link
          to="/categories"
          className="inline-block bg-white text-primary-500 hover:bg-background-100 px-8 py-3 rounded-md font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          {t('cta.button')}
        </Link>
      </div>
    </section>
  );
}